<template>
  <div>
    <div v-for="question in step.fuelFunctionQuestions" :key="question.id" class="mb-1">
      <div>
        <b> {{ question.text }}</b>
      </div>
      <div>Rated {{ question.answer }}/{{ question.maxValue }}</div>
    </div>
    <div v-for="question in step.venuePulseQuestions" :key="question.id" class="mb-1">
      <div>
        <b> {{ question.text }}</b>
      </div>
      <div>Rated {{ question.answer }}/{{ question.maxValue }}</div>
    </div>
    <div v-for="question in step.elaborationQuestions" :key="question.id" class="mb-1">
      <div>
        <b> {{ question.text }}</b>
      </div>
      <div v-if="question.answer" class="whitespace-pre-wrap">{{ question.answer }}</div>
      <div v-else><i>No comment</i></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["step", "meetingInstance"],
};
</script>

